import { post, excluir, get } from './AcessoApi'
import { mostrarToast } from '../components/Toasts'
import { getUsuario } from './Configuracoes'
import moment from 'moment'
import LZString from 'lz-string';

const ordenarArrayObj = (array, atributo) => array.sort((a, b) => a[atributo] > b[atributo] ? 1 : b[atributo] > a[atributo] ? -1 : 0)

const downloadArquivoS3 = (s3Key) => {
    Promise.resolve(post('/sistema/aws-s3-obter-arquivo', {
        fileKey: s3Key
    })).then(val => {
        window.open(val.data.returnData, "_blank")
    }).catch((e) => mostrarToast('erro', e))
}

const auditar = (acao, modulo, controle) => {
    const objAuditar = {
        usuario_id: getUsuario().id,
        modulo_id: modulo,
        acao_id: acao,
        controle: controle || null
    }

    post('/controleAcesso/auditoria/salvar', objAuditar)
}

const removeAcentos = (str) => {
    let comAcento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ'
    let semAcento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr'
    let novaString = ''

    for (let i = 0; i < str.length; i++) {
        let troca = false;

        for (let a = 0; a < comAcento.length; a++)
            if (str.substr(i, 1) === comAcento.substr(a, 1)) {
                novaString += semAcento.substr(a, 1);
                troca = true;
                break;
            }

        if (troca === false)
            novaString += str.substr(i, 1);
    }

    return novaString;
}

const removerCaracteresEspeciais = (str) => {
    return str ? str.replace(/[^\w\s]/gi, '') : str;
}

const emptyObject = obj => {
    for (var key in obj)
        if (obj.hasOwnProperty(key))
            return false;

    return true;
}

const calcularData = (data_base, valor, modo_visualizacao, callback) => {
    let novosFiltros = { modo_visualizacao: modo_visualizacao }
    let tipoContagem = '';
    let today = moment(data_base, 'DD/MM/YYYY');
    switch (modo_visualizacao) {
        case 1:
            today = valor === 0 ? moment() : today;
            tipoContagem = 'days'

            if (valor.toString().includes('/')) {
                novosFiltros = {
                    data_inicial: valor,
                    data_final: valor, ...novosFiltros
                }
            } else {
                today = valor === 0 ? moment() : today;
                novosFiltros = {
                    data_inicial: today.clone().add(valor, tipoContagem).format('DD/MM/YYYY'),
                    data_final: today.clone().add(valor, tipoContagem).format('DD/MM/YYYY'), ...novosFiltros
                }
            }
            break;
        case 2:
            let from_date
            let to_date
            tipoContagem = 'weeks'

            if (valor.toString().includes('/')) {
                today = moment(valor, 'DD/MM/YYYY');
                from_date = today.startOf('week').toDate()
                to_date = today.endOf('week').toDate()
            }
            else {
                from_date = today.startOf('week').toDate()
                to_date = today.endOf('week').toDate()
            }

            novosFiltros = {
                data_inicial: moment(from_date).add(valor, tipoContagem).format('DD/MM/YYYY'),
                data_final: moment(to_date).add(valor, tipoContagem).format('DD/MM/YYYY'), ...novosFiltros
            }
            break;
        case 3:
            tipoContagem = 'months'
            let from_date_month
            let to_date_month

            if (valor.toString().includes('/')) {
                today = moment(valor, 'DD/MM/YYYY');
                from_date_month = today.startOf('month').toDate()
                to_date_month = today.endOf('month').toDate()
            }
            else {
                from_date_month = today.startOf('month').toDate()
                to_date_month = today.endOf('month').toDate()
            }

            novosFiltros = {
                data_inicial: moment(from_date_month).add(valor, tipoContagem).format('DD/MM/YYYY'),
                data_final: moment(to_date_month).add(valor, tipoContagem).endOf('month').format('DD/MM/YYYY'), ...novosFiltros
            }

            break;
        default:
            break;
    }
    return novosFiltros;
}

const formatMoeda = value => {
    return ((value || 0) / 100 * 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', })
}

const formatTwoPlace = value => value ? (value / 100 * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0'

const capitalize = string => string.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())

const reduzTexto = (text, length) => {
    if (text == null) {
        return "";
    }
    if (text.length <= length) {
        return text;
    }
    text = text.substring(0, length);
    let last = text.lastIndexOf(" ");
    text = text.substring(0, last);
    return text + "...";
}

const comprimirString = (data) => {
    const compressedData = LZString.compressToBase64(data);
    return compressedData;
};

function removeContentBetweenDivs(htmlString, startClassName, endClassName) {
    // Crie uma expressão regular para encontrar o conteúdo entre as divs
    var regex = new RegExp('<div[^>]*\\b' + startClassName + '\\b[^>]*>.*?</div>(.*?)<div[^>]*\\b' + endClassName + '\\b[^>]*>', 'gi');

    var modifiedHtmlString = htmlString.replace(regex, '');

    return modifiedHtmlString;
};

const stringSizeMB = (str) => {
    const byteLength = Buffer.from(str).length;
    const megabytes = byteLength / (1024 * 1024);
    return megabytes.toFixed(2);
}

const copyScheduleToClipboard = (agendamentos) => {
    let clipboardContent = '';
    agendamentos.forEach((agendamento, index) => {
        clipboardContent += `Agendamento:\n*${agendamento.status}*\n*${agendamento.data}* ${agendamento.hora_inicial} - ${agendamento.hora_final}\n${agendamento.medico}\n*Paciente:* ${agendamento.paciente}\n*Observação:* ${agendamento.observacao}\n\n`;
        if (index !== agendamentos.length - 1) {
            clipboardContent += '---------------------------------\n\n';
        }
    });

    return copyToClipboard(clipboardContent);
}

function copyToClipboard(str) {
    navigator.clipboard.writeText(str).then(() => {
        mostrarToast('sucesso', 'Copiado para a área de transferência.', 5000)
    }).catch((error) => {
        mostrarToast('erro', 'Erro ao copiar para a área de transferência.', 5000)
    });
}

export {
    excluir, auditar, removeAcentos, ordenarArrayObj, emptyObject, calcularData, formatMoeda, formatTwoPlace, capitalize, reduzTexto, removerCaracteresEspeciais,
    comprimirString, removeContentBetweenDivs, stringSizeMB, downloadArquivoS3, copyToClipboard, copyScheduleToClipboard
}